// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3QjQW","menu":"footer-module--menu--34WBm","title":"footer-module--title--3U-vd"};